import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFilePsd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 165,
	height: 217,
	viewBox: "0 0 165 217",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M139.67 49.25C134.202 49.2447 128.959 47.0708 125.092 43.2053C121.224 39.3397 119.048 34.0981 119.04 28.63V0H26.9099C23.3752 -2.4406e-07 19.8751 0.696337 16.6096 2.04932C13.3441 3.4023 10.3771 5.38537 7.87818 7.88525C5.37922 10.3851 3.39718 13.3529 2.04541 16.6189C0.693646 19.8849 -0.00131167 23.3853 1.85979e-06 26.92V189.14C-0.00131223 192.674 0.693768 196.174 2.04566 199.44C3.39754 202.705 5.37982 205.672 7.87891 208.171C10.378 210.67 13.3449 212.652 16.6104 214.004C19.8758 215.356 23.3757 216.051 26.9099 216.05H137.51C144.647 216.05 151.492 213.215 156.538 208.168C161.585 203.122 164.42 196.277 164.42 189.14V49.25H139.67Z",
				fill: "#005FAD"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.42 49.25H139.67C134.202 49.2447 128.959 47.0708 125.092 43.2053C121.224 39.3397 119.048 34.0981 119.04 28.63V0L164.42 49.25Z",
			fill: "#005FAD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.0498 130.82C50.0498 130.82 43.5397 116.99 51.9597 103.48C51.9597 103.48 54.4598 110.75 56.5098 110.27C56.5098 110.27 53.8998 99.8601 55.8198 96.7801C55.8198 96.7801 64.1398 84.8501 73.3198 78.4001C73.3198 78.4001 73.6098 85.5001 75.7698 86.0801C75.7698 86.0801 75.4297 81.7001 78.4897 75.0801C78.4897 75.0801 93.2797 63.6801 117.98 64.7201C117.98 64.7201 108.23 79.8102 102.76 90.0002C99.8641 95.5 96.6761 100.841 93.2097 106C93.2097 106 85.9498 110.25 81.2698 109.85C81.2698 109.85 85.2699 112.98 89.6099 111.43C89.6099 111.43 78.6096 131.43 57.1196 133.95C57.1196 133.95 53.1198 142.19 52.3098 149.39C52.3098 149.39 48.3097 151.81 46.4297 151.39C46.4297 151.39 56.8097 111.55 92.1497 82.6902C92.1497 82.6902 71.7398 88.0902 50.0498 130.82Z",
			fill: "#005FAD"
		})
	]
});
export default SvgIconFilePsd;
